import React from "react";
import { ReactComponent as Logo } from "./TuluFooter.svg";
export default function Footer() {
  return (
    <div
      style={{ display: "flex", position: "absolute", bottom: 28, left: 100 }}
    >
      <Logo style={{ height: 52, width: 180 }} />
      <div style={{ fontSize: 22, marginLeft: 24, marginTop: 20 }}></div>
    </div>
  );
}
